<template>
  <div>
    <h1 v-show="!showSuccessMessage" class="login__title mb-8">
      {{ $t('auth.resetPassword') }}
    </h1>

    <div v-show="showSuccessMessage" class="text-center">
      <v-icon class="text-h1 green--text">mdi-check-circle-outline</v-icon>
      <h2 class="grey--text mt-8 mb-2">
        {{ $t('auth.success.resetPassword') }}
      </h2>
      <v-btn
        @click="$router.push('/login')"
        color="primary"
        class="px-2"
        depressed
        large
        text
      >
        <h5 class="d-flex">
          <v-icon left>mdi-chevron-left</v-icon>
          {{ $t('auth.goBackToLogin') }}
        </h5>
      </v-btn>
    </div>

    <v-form v-show="!showSuccessMessage" @submit.prevent="validate" ref="form" lazy-validation>
      <v-text-field
        v-model="newPassword"
        :label="$t('profile.updatePassword.label.newPassword')"
        :rules="[rules.required, rules.differentFromCurrentPassword]"
        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="showPassword = !showPassword"
        :type="showPassword ? 'text' : 'password'"
        outlined
      />
      <v-text-field
        v-model="repeatedNewPassword"
        :label="$t('profile.updatePassword.label.repeatNewPassword')"
        :rules="[rules.required, rules.sameAs, rules.differentFromCurrentPassword]"
        :type="showPassword ? 'text' : 'password'"
        outlined
      />

      <v-row no-gutters>
        <v-col>
          <div class="text-right">
            <v-btn
              :loading="isLoading"
              color="primary"
              type="submit"
              depressed
              large
            >
              <span class="text-body-1 font-weight-medium">
                {{ $t('auth.update') }}
              </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { api } from '../../services'
import { email, required } from '@/util/errorHandling'
import { mapActions } from 'vuex'

export default {
  name: 'ResetPasswordForm',

  methods: {
    ...mapActions(['showErrorMessage']),

    createPayload() {
      const passwordToBase64 = btoa(this.newPassword)

      return  {
        encoded_password: passwordToBase64,
        reset_password_token: this.$route?.params?.token,
      }
    },

    async validate() {
      if (!this.$refs.form.validate()) return
      if (!this.$route?.params?.token) return this.showErrorMessage(this.$t('auth.error.invalidToken'))

      this.isLoading = true

      await api.post('web/open/user/resetPassword', this.createPayload())
        .then(() => this.showSuccessMessage = true)
        .catch(({ data }) => this.showErrorMessage(data.message))
        .finally(() => this.isLoading = false)
    }
  },

  data() {
    return {
      isLoading: false,
      showPassword: false,
      showSuccessMessage: false,

      username: '',
      newPassword: '',
      repeatedNewPassword: '',

      rules: {
        email,
        required,
        sameAs: v => v === this.newPassword || this.$t('profile.updatePassword.messages.passwordsDoNotMatch'),
        differentFromCurrentPassword: v => v !== this.currentPassword || this.$t('profile.updatePassword.messages.repeatNewPassword')
      },
    }
  }
}
</script>
